import { addRequirements } from './requirements.js'
import { status, globalRules } from './common.js';
import validator from './veriflcation';
import combinationManager from './combination';
// let groups = [{ //套餐数据（没有套餐则不传）
//   index: '', // 索引
//   num: '', //数量（相同的套餐增加数量）（必传）
//   isScore: false, // 是否积分兑换餐品
//   mains: [{ // 主食区列表
//     mid: '', //主食区id（必传）
//     name: '', //主食区名字
//     groups: [{ //组集合
//       gid: '', //组id（必传）
//       type: '', //组类型（必传）
//       name: '', //组名字
//       products: [{ //餐品集合
//         itemIndex: '', //item索引（C、D板块必传）
//         index: '', //索引（C、D板块必传）
//         pid: '', //餐品id（必传）
//         name: '', //餐品名称
//         title: '', // C组分类标题
//         price: '', //餐品价格(如果是餐品组合，使用餐品组合的价格，不要使用组合里餐品的价格)（必传）
//         num: '', //数量（必传）
//         isCombination: false, //是否餐品组合
//         combinationId: '', //餐品组合id
//         listPropertys: [{ //特殊要求，参照单品的特殊要求
//           index: '', //所在索引
//           propertys: [{
//             pid: '', //特殊要求id
//             items: [{ //特殊要求集合
//               index: '', //索引
//               num: '', //可选特殊要求的份数
//               alterNum: '', //可选特殊要求变动份数（没变动的项不用传）
//               alterPrice: '', //可选特殊要求变动价钱
//             }]
//           }]
//         }]
//       }]
//     }]
//   }]，
//   exArea: { //副食区，参照主食区
//     name: '', // 副食区名字
//     groups: [{ //组集合
//       gid: '', //组id
//       type: '', //组类型
//       name: '', //组名字
//       products: [{ // 餐品集合
//         itemIndex: '', //item索引
//         index: '', //索引
//         pid: '', //餐品id
//         name: '', //餐品名称
//         title: '', //C组分类标题
//         price: '', //餐品价格
//         num: '', //数量
//         isCombination: false, //是否餐品组合
//         combinationId: '', //餐品组合id
//         listPropertys: [{ //特殊要求，参照单品的特殊要求
//           index: '', //所在索引
//           propertys: [{ //特殊要求集合
//             pid: '', //特殊要求id
//             items: [{ //特殊要求集合
//               index: '', //索引
//               num: '', //可选特殊要求的份数
//               alterNum: '', //可选特殊要求变动份数（没变动的项不用传）
//               alterPrice: '', //可选特殊要求变动价钱
//             }]
//           }]
//         }]
//       }]
//     }]
//   }
// }]

// let listPaht = 'groups-mains-groups-products-listPropertys-propertys-items';

// 如果自定义规则触发，则存放错误的地方
const errorStack = [];

// 当前选择套餐的总数
let totalNum = 0;

/**
  * 格式化A区套餐
  * @params {object} group 当前A区套餐数据
  * @params {object} 格式化当前套餐数据需要的额外信息:
  *   - path {string}: 父对象路径，
  *   - groupName {string}: 当前区的名字，
  *   - selectCellsIndex {boolean|number}: 是否指定选择哪个A套餐，如果指定，则传当前选择的套餐下标，默认为false
*/
const addGroupA= (group, { path, groupName, selectCellsIndex = false }) => {
  if (group !== undefined && group.cells && group.cells.length) {
    let cells;
    if (selectCellsIndex) {
      cells = group.cells[selectCellsIndex];
    } else {
      cells = group.cells[0];
    }
    let groupData = {
      gid: cells.pid,
      type: group.type,
      name: group.title,
      nameEn: group.titleEn || group.title,
      products: []
    };
    let products = addProducts(
      [cells],
      path + '.products',
      groupData.products.length,
      { title: group.title, titleEn: group.titleEn, productsIndex : 0, groupName: 'A', num: 1 }
    );
    groupData._means = Object.assign(Object.create({ _config: { maxNum: group.maxNum || Infinity }  }), groupData);
    // Object.defineProperty(groupData, '_means', {
    //   value: { config: { maxNum: group.maxNum || Infinity }  }
    // });
    if (errorStack.length === 0) {
      groupData.products = products;
    }
    return groupData;
  }
}

/**
  * 格式化B区套餐
  * @params {object} group 当前B区套餐数据
  * @params {object} 格式化当前套餐数据需要的额外信息:
  *   - path {string}: 父对象路径，
  *   - groupName {string}: 当前区的名字，
*/
const addGroupB = (group, { path, groupName }) => {
  if (group !== undefined && group.cells && group.cells.length) {
    let groupData = {
      gid: 2,
      type: group.type,
      name: group.title,
      nameEn: group.titleEn || group.title,
      products: []
    };
    let products = addProducts(
      group.cells,
      path + '.products',
      groupData.products.length,
      { title: group.title, titleEn: group.titleEn, productsIndex: 0, groupName: 'B', num: 0 }
    )
    if (errorStack.length === 0) {
      groupData.products = products;
    }
    return groupData;
  }
}

/**
  * 添加详细套餐数据的公用方法
  * @params {object} arr 当前套餐数据
  * @params path {string}: 父对象路径，
  * @params productsLen {string}: 当前Products数组对象的length
  * @params {object} 格式化当前套餐数据需要的额外信息:
  *   - groupName {string}: 当前区的名字，
  *   - title {string}: 分类标题
  *   - productsIndex {number}: cd区，item索引
  *   - num { number }: 数量
*/
const addProducts = (arr, path, productsLen, { title = '', titleEn = '', productsIndex, groupName, num, rules = [] }) => {
  let products = [];
  let proLen = productsLen;
  for (let cellsIndex = 0; cellsIndex < arr.length; cellsIndex ++) {
    let cells = arr[cellsIndex];
    if (cells.isSoldOut) {
      continue;
    }
    groupName === 'B' && (num = cells.maxNum);
    if (cells.hasInventory && typeof cells.inventoryNum === 'number' && num > cells.inventoryNum) {
      num = cells.inventoryNum;
    }
    let cellsItem, prototype = {};
    if (!cells.isCombination) {
      cellsItem = {
        itemIndex: productsIndex, // item索引
        index: cellsIndex, // 索引
        pid: cells.pid, // 餐品id
        name: cells.name, // 餐品名称
        nameEn: cells.nameEn || cells.name,
        title, // 分类标题
        titleEn: titleEn || title,
        num,
        price: cells.price,
        isCombination: false,
        combinationId: 0,
      }
      let config = {
        isSoldOut: cells.isSoldOut,
        hasInventory:  cells.hasInventory,
        inventoryNum: cells.inventoryNum,
        num: cellsItem.num
      };
      let startValidator = validator(rules, config);
      if (startValidator.length) {
        errorStack.push(...startValidator);
      } else {
        totalNum += config.num;
        delete config.num;
      }
      if (groupName === 'D') { // 如果是D区
        if(cells.minNum !== undefined) {
          config.minNum = cells.minNum || Infinity;
        }
        if (cells.maxNum !== undefined) {
          config.maxNum = cells.maxNum || Infinity;;
        }
      }
      prototype.config = config;
      // Object.defineProperty(cellsItem, '_means', {
      //   value: { config }
      // });
      if (cells.isRequirement) {
        // addRequirements(food.requirements, listRequirements.length, num, products._means.getPath);
        cellsItem.listPropertys = [];
        cellsItem.listPropertys._means = {
          getPath:  path + '[' + proLen +'].listPropertys'
        }
        let listPropertys = addRequirements(
          cells.requirements,
          cellsItem.listPropertys,
          1,
          true
        );
        cellsItem.listPropertys.push(listPropertys);
      }
    }
    prototype.getPath = path + '[' + proLen +']';
    cellsItem._means = prototype;
    // Object.defineProperty(cellsItem, '_means', {
    //   value: prototype
    // });
    proLen += 1;
    if (errorStack.length === 0) {
      // cellsItem = Object.assign(Object.create(prototype), cellsItem);
      products.push(cellsItem);
    }
  }
  // let products = arr.map((cells, cellsIndex) => {
  //   return cellsItem;
  // });
  return products;
}

/**
  * 格式化C|D区套餐
  * @params {object} group 当前C|D区套餐数据
  * @params {object} 格式化|添加 当前套餐数据需要的额外信息:
  *   - path {string}: 父路径，
  *   - groupName {string}: 当前区的名字，
  *   - num {number}: 数量
  *   - selectIndex {number}: C区cell索引
*/
const addGroupCD = (group, { path, groupName, num = 0, selectIndex = false }) => {
  if (
    group !== undefined
    && group.items
    && group.items.length
  ) {
    let config = {
      maxNum: group.maxNum || Infinity
    };
    let items = {
      gid: groupName === 'D' ? 4: 3,
      type: group.type,
      name: group.title,
      nameEn:  group.titleEn || group.title,
      products: []
    }
    group.items.forEach((products, productsIndex) => {
      let dataItems, productsConfig = {};
      ['isNeedSelect', 'canSelectNum', 'minNum', 'maxNum'].forEach((item) => {
        if(products[item] !== undefined) {
          productsConfig[item] = products[item];
        }
      });
      productsConfig.totalMaxNum = config.maxNum;
      if (groupName === 'C') {
        if (products.isNeedSelect && products.cells.length) {
          // let setNum = 1;
          let addProductsData;
          if (selectIndex && selectIndex >= 0 && selectIndex <= cells.length) {
            addProductsData = [products.cells[selectIndex]];
          } else {
            addProductsData = [products.cells[0]]
          }
          dataItems = addProducts(
            addProductsData,
            path + '.products',
            items.products.length,
            { title: products.title, titleEn:  products.titleEn, productsIndex, groupName, num: 1 }
          );
        }
      } else if (groupName === 'D' && num) {
        dataItems = addProducts(
          products.cells,
          path + '.products',
          items.products.length,
          { title: products.title, titleEn:  products.titleEn, productsIndex, groupName, num }
        );
      }
      if (errorStack.length === 0 && dataItems) {
        dataItems._means = { _config: productsConfig };
        // Object.defineProperty(dataItems, '_means', {
        //   value: { config : productsConfig }
        // });
        items.products.push(...dataItems);
      }
    });
    items._means = { _config: config };
    // Object.defineProperty(items, '_means', {
    //   value: { config }
    // });
    return items;
  }
}

/**
  * 根据类型添加相应的套餐区域{A,B,C,D}
  * @params {object} group 当前区域套餐数据
  * @params {number} option 选项
*/
const addGroupType = (newGroup, oldGroup, option) => {
  let obj;
  if (!option.groupName && !option.path) {
    return;
  }
  if (!option.productsIndex) {
    option.productsIndex = 0;
  }
  let path = '';
  if (oldGroup._means.getPath) {
    const reg = /\[\d+\]$/;
    if (reg.test(oldGroup._means.getPath)) {
      path = oldGroup._means.getPath.replace(reg, '');
    }
  }
  obj = addProducts(
    newGroup,
    path,
    oldGroup.length || 0,
    option);
  if (obj) {
    return obj;
  }
  return false;
}

/**
  * 递归为每一个套餐对象添加_means字段
  * @params {object} groupData 套餐数据
  * @params {number} index _products数组的下标
*/
const loaderGroupList = (groupData, mainPath) => {
  let arr = ["groups", "products", "listPropertys", "propertys", "items"];
  const loader = (groups, path, keys) => {
    const key = keys.shift();
    let data;
    if (Array.isArray(groups)) {
      obosever(groups, {
        getPath: path + '.' + key
      });
      data = groups;
    } else {
      obosever(groups[key], {
        getPath: path + '.' + key
      });
      data = groups[key];
    }
    for (let i = 0; i < data.length; i ++) {
      obosever(data[i], {
        getPath: path + '.' + key + '[' + i + ']'
      });
      if (keys.length) {
        const nextKey = keys[0];
        if (data[i][nextKey]) {
          loader(data[i][nextKey],  path + '.' + key + '[' + i + ']', keys);
        }
      }
    }
  }
  loader(groupData, mainPath, arr);
}

const obosever = (obj, option) => {// 为obj对象添加_means属性
  if (obj) {
    obj._means = {...option}
  }
  // Object.defineProperty()
}

/**
  * 添加新的套餐，初始化套餐数据
  * @params {object} group 套餐数据
  * @params {number} superIndex 父下标
  * @params {number} selectCellsIndex 是否指定选择哪个A套餐，如果指定，则传当前选择的套餐下标， 默认为false
*/
const addGroups4 = (group, superIndex = 0, num, path  = '', selectCellsIndex = false) => {
  if (typeof path === 'object') {
    if (path._means) {
      path = path._means.getPath;
    } else {
      path = '';
    }
  }
  if (group.length === 0) {
    return {
      status: false,
      message: status.params
    };
  }
  if (group.isSoldOut) {
    return status.isSoldOut;
  }
  let data = {
    index: superIndex,
    num: 1,
    isScore: group.isScore || false,
    mains: []
  };
  let gid = '';
  if (group.mainFoodAreas !== undefined && group.mainFoodAreas.length) {
    data.mains = group.mainFoodAreas.map((item, index) => { // 添加一个或多个主食
      let mains = {
        mid: item.areaId,
        groups: []
      }
      mains.groups._means = {
        getPath:  path + '.groups'
      }
      if (item.hasOwnProperty('groupA') && item.groupA.cells && item.groupA.cells.length) {
        let A;
        let aPath = path + '.groups[' + superIndex + ']' + '.mains[' + index + '].groups[' + mains.groups.length + ']';
        if (selectCellsIndex) {
          A = addGroupA(item.groupA, { path: aPath, groupName: 'A', selectCellsIndex });
        } else {
          A = addGroupA(item.groupA, { path: aPath, groupName: 'A' });
        }
        if (A) {
          A._means = { getPath: aPath };
          // Object.defineProperty(A, '_means', {
          //   value: { getPath: aPath }
          // });
          gid = A.gid;
          mains.groups.push(A);
          let groupList = ['groupB', 'groupC', 'groupD'];
          groupList.forEach((itemsName) => {
            if (item.associatedGroups[A.gid].hasOwnProperty(itemsName)) {
              let gPath = path + '.groups[' + superIndex + ']' + '.mains[' + index + '].groups[' + mains.groups.length + ']';
              let groupName = itemsName.slice(-1);
              let group;
              if (groupName === 'C' || groupName === 'D') {
                group = addGroupCD(item.associatedGroups[A.gid][itemsName], {
                  path: gPath,
                  groupName,
                  id: A.gid
                });
              } else if (groupName === 'B') {
                group = addGroupB(item.associatedGroups[A.gid][itemsName], {
                  path: gPath,
                  groupName,
                  id: A.gid
                });
              }
              if (typeof group !== 'undefined' && errorStack.length === 0) {
                group._means = { getPath: gPath };
                mains.groups.push(group);
                // Object.defineProperty(group, '_means', {
                //   value: { getPath: gPath }
                // });
              }
            }
          });
        }
      }
      return mains;
    });
  }
  if (group.hasExtArea && group.extFoodArea !== undefined) {
    data.exArea = {
      name: group.extFoodArea.title,
      groups: []
    }
    let groupList = ['groupB', 'groupC', 'groupD'];
    data.exArea.groups._means = {
      getPath: path + '.groups'
    }
    groupList.forEach((itemsName) => {
      if (group.extFoodArea.hasOwnProperty(itemsName)) {
        let gPath = path + '.groups[' + superIndex + ']' + '.exArea.groups[' + data.exArea.groups.length + ']';
        let groupName = itemsName.slice(-1);
        let groupData;
        if (groupName === 'C' || groupName === 'D') {
          groupData = addGroupCD(group.extFoodArea[itemsName], {
            path: gPath,
            groupName,
            id: gid
          });
        } else if (groupName === 'B') {
          groupData = addGroupB(group.extFoodArea[itemsName], {
            path: gPath,
            groupName,
            id: gid
          }); 
        }
        if (typeof groupData !== 'undefined' && errorStack.length === 0) {
          groupData._means = { getPath: gPath };
          // Object.defineProperty(groupData, '_means', {
          //   value: { getPath: gPath }
          // });
          data.exArea.groups.push(groupData);
        }
      }
    });
  }
  if (errorStack.length) {
    const error = {
      state: false,
      error: [].concat(errorStack)
    };
    errorStack.length = 0;
    return error;
  }
  const success = {
    status: true,
    data,
    totalNum
  }
  totalNum = 0;
  return success;
}

export default {
  addGroups4,
  addGroupType,
  loaderGroupList
};


// WEBPACK FOOTER //
// ./../../plugins/cart/group4.js